(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
(function(){
  // 仅保留优雅的入场动画
  var obs = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add('visible');
        obs.unobserve(e.target);
      }
    });
  }, {threshold: 0.1});
  
  document.querySelectorAll('.s6-anim').forEach(function(el){
    obs.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-story"] && !Shopify.designMode) return;
  try {
    
(function(){var o=new IntersectionObserver(function(e){e.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');o.unobserve(e.target)}})},{threshold:.15});document.querySelectorAll('.s9-anim-img,.s9-anim-text').forEach(function(e){o.observe(e)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
(function(){
  // 仅保留进场动画，移除滑动相关JS
  var obs=new IntersectionObserver(function(es){
    es.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add('visible');
        obs.unobserve(e.target);
      }
    });
  },{threshold:0.1});
  
  document.querySelectorAll('.s5-anim').forEach(function(el){
    obs.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-two-col"] && !Shopify.designMode) return;
  try {
    
(function(){var o=new IntersectionObserver(function(e){e.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');o.unobserve(e.target)}})},{threshold:.1});document.querySelectorAll('.s8-anim,.s8-anim-1,.s8-anim-2').forEach(function(e){o.observe(e)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
  var section = document.querySelector('.s3-hero');
  if (!section) return;
  var id = section.closest('[id]');
  var slides = section.querySelectorAll('.s3-slide');
  var dots = section.querySelectorAll('.s3-dot');
  var textEl = section.querySelector('.s3-text');
  var idx = 0, timer;
  var speed = parseInt(section.dataset.speed) || 5500;

  function go(i) {
    slides[idx].classList.remove('active');
    if (dots[idx]) dots[idx].classList.remove('active');
    idx = i;
    var s = slides[idx];
    s.classList.add('active');
    if (dots[idx]) dots[idx].classList.add('active');

    textEl.classList.remove('s3-anim');
    void textEl.offsetWidth;

    var tag = textEl.querySelector('.s3-tag');
    var title = textEl.querySelector('.s3-title');
    var desc = textEl.querySelector('.s3-desc');
    var btnP = textEl.querySelector('.s3-btn-p');
    var btnO = textEl.querySelector('.s3-btn-o');

    if (tag) tag.textContent = s.dataset.tag || '';
    if (title) title.innerHTML = (s.dataset.title || '').replace(/\\n/g, '<br>');
    if (desc) desc.textContent = s.dataset.desc || '';
    if (btnP && s.dataset.cta) {
      btnP.innerHTML = s.dataset.cta + ' &nbsp;\u2192';
      btnP.href = s.dataset.link || '#';
    }
    if (btnO && s.dataset.cta2) {
      btnO.textContent = s.dataset.cta2;
      btnO.href = s.dataset.link2 || '#';
    }

    textEl.classList.add('s3-anim');
    clearInterval(timer);
    timer = setInterval(function(){ go((idx + 1) % slides.length); }, speed);
  }

  dots.forEach(function(d, i){
    d.addEventListener('click', function(){ go(i); });
  });

  timer = setInterval(function(){ go((idx + 1) % slides.length); }, speed);
  setTimeout(function(){ textEl.classList.add('s3-anim'); }, 200);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
(function(){var o=new IntersectionObserver(function(e){e.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');o.unobserve(e.target)}})},{threshold:.1});document.querySelectorAll('.s12-anim').forEach(function(e){o.observe(e)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
(function(){var o=new IntersectionObserver(function(e){e.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');o.disconnect()}})},{threshold:.15});document.querySelectorAll('.s13-anim').forEach(function(e){o.observe(e)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
(function(){var o=new IntersectionObserver(function(e){e.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');o.disconnect()}})},{threshold:.15});document.querySelectorAll('.s7-anim').forEach(function(e){o.observe(e)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
(function(){var o=new IntersectionObserver(function(e){e.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');o.unobserve(e.target)}})},{threshold:.1});document.querySelectorAll('.s11-anim').forEach(function(e){o.observe(e)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-grid"] && !Shopify.designMode) return;
  try {
    
(function(){var o=new IntersectionObserver(function(e){e.forEach(function(e){if(e.isIntersecting){e.target.classList.add('visible');o.unobserve(e.target)}})},{threshold:.1});document.querySelectorAll('.s10-anim').forEach(function(e){o.observe(e)})})();

  } catch(e) { console.error(e); }
})();
})();
